import * as yup from 'yup';
import i18n from '@core/i18n';

const roofSchema = yup.object().shape({
  roof_area: yup.number(),
  useable_roof_area: yup.number().max(100, i18n.t('project.errors.shouldBeLess', { number: 100 })),
  orientation: yup.string().when('roof_area', {
    is: (value: number | '') => value !== '' && value > 0,
    then: (schema) => schema.required(i18n.t('project.errors.required')),
    otherwise: (schema) => schema.notRequired(),
  }),
  inclination_of_roof: yup.string().when('roof_area', {
    is: (value: number | '') => value !== '' && value > 0,
    then: (schema) => schema.required(i18n.t('project.errors.required')),
    otherwise: (schema) => schema.notRequired(),
  }),
});

export const createProjectSchema = yup.object().shape({
  project_name: yup.string().required(i18n.t('project.errors.required')),
  project_description: yup.string().max(100, i18n.t('project.errors.maxLength', { number: 100 })),
  customer_name: yup.string(),
  postal_code: yup.string(),
  number_of_units: yup.number().required(i18n.t('project.errors.required')),
  heated_area: yup.number().required(i18n.t('project.errors.required')).min(1, i18n.t('project.errors.shouldBeGreater')),
  exterior_area: yup.number().required(i18n.t('project.errors.required')),
  building_year: yup.number().required(i18n.t('project.errors.required'))
    .min(1900, i18n.t('project.errors.shouldBeBetween', { min: 1900, max: 2030 }))
    .max(2030, i18n.t('project.errors.shouldBeBetween', { min: 1900, max: 2030 })),
  building_current_status: yup.string(),
  hwb_from_ea_as_planned: yup.string(),
  type_of_infrastructure: yup.string().required(i18n.t('project.errors.required')),
  pv_basic_power_and_module_determination: yup.array().of(roofSchema),
  with_thermal_renovation: yup.boolean(),
  general_comment: yup.string().max(5000, i18n.t('project.errors.maxLength', { number: 5000 })),

  type_of_heating_distribution_w: yup.string().required(i18n.t('project.errors.required')),
  type_of_warmwater_distribution_ww: yup.string().required(i18n.t('project.errors.required')),
  type_of_warmwater_generation: yup.string(),

  // Basic mode fields
  heating_performance_total: yup.number().required(i18n.t('project.errors.required')),
  heating_consumption_total: yup.number().required(i18n.t('project.errors.required')),

  // Expert mode fields
  heating_power: yup.number(),
  heating_consumption: yup.number(),
  warm_water_power: yup.number(),
  warm_water_consumption: yup.number(),
  temperature_conditioning_power: yup.number(),
  temperature_conditioning_consumption: yup.number(),
});
